module.exports = __webpack_public_path__ + "static/media/shopify.0a736bf9.jpg";